/*
This file is generated.
Do not modify manually, instead refer to build-sounds.js
*/
// tslint:disable
/* es-lint:disable */
export var IdSound;
(function (IdSound) {
    IdSound["MU_Main_01"] = "MU_Main_01";
    IdSound["Dog_Bark"] = "Dog_Bark";
    IdSound["UI_SpendGold"] = "UI_SpendGold";
    IdSound["Dog_Celebration_NoCollar"] = "Dog_Celebration_NoCollar";
    IdSound["Dog_Howl"] = "Dog_Howl";
    IdSound["Dog_IdleLong"] = "Dog_IdleLong";
    IdSound["Dog_IdlePlayful"] = "Dog_IdlePlayful";
    IdSound["Dog_IdlePlayful_NoCollar"] = "Dog_IdlePlayful_NoCollar";
    IdSound["Dog_Sniff"] = "Dog_Sniff";
    IdSound["Dog_Sniff_NoCollar"] = "Dog_Sniff_NoCollar";
    IdSound["Dog_Whine"] = "Dog_Whine";
    IdSound["SFX_Truck_Loop"] = "SFX_Truck_Loop";
    IdSound["SFX_Truck_Start"] = "SFX_Truck_Start";
    IdSound["SFX_Truck_Stop"] = "SFX_Truck_Stop";
    IdSound["UI_BuildingCelebration"] = "UI_BuildingCelebration";
    IdSound["UI_BuildingFinish"] = "UI_BuildingFinish";
    IdSound["UI_BuildingPick"] = "UI_BuildingPick";
    IdSound["Dog_Celebration"] = "Dog_Celebration";
    IdSound["UI_BuildingRotate"] = "UI_BuildingRotate";
    IdSound["UI_Collectwater"] = "UI_Collectwater";
    IdSound["UI_ContractTrash"] = "UI_ContractTrash";
    IdSound["UI_Generic"] = "UI_Generic";
    IdSound["UI_HarvestReady"] = "UI_HarvestReady";
    IdSound["UI_ItemCollect"] = "UI_ItemCollect";
    IdSound["UI_ItemSold"] = "UI_ItemSold";
    IdSound["UI_ItemSpawn"] = "UI_ItemSpawn";
    IdSound["UI_LevelUp"] = "UI_LevelUp";
    IdSound["UI_ProduceFeed"] = "UI_ProduceFeed";
    IdSound["UI_ProduceFertilise"] = "UI_ProduceFertilise";
    IdSound["UI_ProduceProduct"] = "UI_ProduceProduct";
    IdSound["UI_ProduceSow"] = "UI_ProduceSow";
    IdSound["UI_QuestComplete"] = "UI_QuestComplete";
    IdSound["UI_Scroll"] = "UI_Scroll";
    IdSound["UI_BuildingPlace"] = "UI_BuildingPlace";
})(IdSound || (IdSound = {}));



//////////////////
// WEBPACK FOOTER
// ./src/setup/sound/IdSound.ts
// module id = 2517
// module chunks = 3